import { createContext } from 'react'

export const UserArtistRatingsContext = createContext(null)
